/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CustomerCRMPage = lazyLoad(
  () => import('./index'),
  module => module.CustomerCRMPage
);
